// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"G50f9c1","item-0":"G672c46","item-1":"G95e483"};